"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTableState = void 0;
var _reactTable = require("@tanstack/react-table");
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Create a unique storage key based table ID
 */

var getStorageKey = function getStorageKey(id, key) {
  return "".concat(id, ".").concat(key);
};

/**
 * Get value from localStorage, fallback to defaultValue if key not found or invalid
 */
function getFromLocalStorage(key, defaultValue) {
  try {
    var item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (_unused) {
    return defaultValue;
  }
}

/**
 * Save the value to localStorage
 */
function setToLocalStorageDebounced(key, value) {
  requestIdleCallback(function () {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (_unused2) {
      // Silent fail
    }
  });
}

/**
 * Hook to manage table state
 */
var useTableState = function useTableState(data, columns, columnIds, tableId, options) {
  var id = tableId !== null && tableId !== void 0 ? tableId : 'default';
  var _ref = options || {},
    _ref$manualPagination = _ref.manualPagination,
    manualPagination = _ref$manualPagination === void 0 ? false : _ref$manualPagination,
    _ref$totalRows = _ref.totalRows,
    totalRows = _ref$totalRows === void 0 ? 0 : _ref$totalRows,
    _ref$initialPageIndex = _ref.initialPageIndex,
    initialPageIndex = _ref$initialPageIndex === void 0 ? 0 : _ref$initialPageIndex,
    _ref$initialPageSize = _ref.initialPageSize,
    initialPageSize = _ref$initialPageSize === void 0 ? 10 : _ref$initialPageSize;
  var _React$useState = React.useState(function () {
      return getFromLocalStorage(getStorageKey(id, 'columnOrder'), columnIds);
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    columnOrder = _React$useState2[0],
    setColumnOrder = _React$useState2[1];
  var _React$useState3 = React.useState(function () {
      return getFromLocalStorage(getStorageKey(id, 'columnVisibility'), {});
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    columnVisibility = _React$useState4[0],
    setColumnVisibility = _React$useState4[1];
  var _React$useState5 = React.useState({
      pageIndex: initialPageIndex,
      pageSize: initialPageSize
    }),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    pagination = _React$useState6[0],
    setPagination = _React$useState6[1];
  // const [pagination, setPagination] = React.useState(
  //   () => getFromLocalStorage(getStorageKey(id, 'pagination'), { pageIndex: 0, pageSize: 10 })
  // );
  var _React$useState7 = React.useState(function () {
      return getFromLocalStorage(getStorageKey(id, 'sorting'), []);
    }),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    sorting = _React$useState8[0],
    setSorting = _React$useState8[1];
  var _React$useState9 = React.useState(function () {
      return getFromLocalStorage(getStorageKey(id, 'expanded'), {});
    }),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    expanded = _React$useState10[0],
    setExpanded = _React$useState10[1];
  var _React$useState11 = React.useState(function () {
      return getFromLocalStorage(getStorageKey(id, 'globalFilter'), '');
    }),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    globalFilter = _React$useState12[0],
    setGlobalFilter = _React$useState12[1];
  var _React$useState13 = React.useState(function () {
      return getFromLocalStorage(getStorageKey(id, 'columnPinning'), {
        left: [],
        right: []
      });
    }),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    columnPinning = _React$useState14[0],
    setColumnPinning = _React$useState14[1];

  /**
   * Automatically save table state changes to localStorage
   */
  React.useEffect(function () {
    return setToLocalStorageDebounced(getStorageKey(id, 'columnOrder'), columnOrder);
  }, [columnOrder, id]);
  React.useEffect(function () {
    return setToLocalStorageDebounced(getStorageKey(id, 'columnVisibility'), columnVisibility);
  }, [columnVisibility, id]);
  React.useEffect(function () {
    return setToLocalStorageDebounced(getStorageKey(id, 'pagination'), pagination);
  }, [id, pagination]);
  React.useEffect(function () {
    return setToLocalStorageDebounced(getStorageKey(id, 'sorting'), sorting);
  }, [id, sorting]);
  React.useEffect(function () {
    return setToLocalStorageDebounced(getStorageKey(id, 'expanded'), expanded);
  }, [expanded, id]);
  React.useEffect(function () {
    return setToLocalStorageDebounced(getStorageKey(id, 'globalFilter'), globalFilter);
  }, [globalFilter, id]);
  React.useEffect(function () {
    return setToLocalStorageDebounced(getStorageKey(id, 'columnPinning'), columnPinning);
  }, [columnPinning, id]);

  /**
   * Initialise table with state
   */
  var table = (0, _reactTable.useReactTable)({
    data: data,
    columns: columns,
    state: {
      columnOrder: columnOrder,
      columnVisibility: columnVisibility,
      pagination: pagination,
      sorting: sorting,
      expanded: expanded,
      globalFilter: globalFilter,
      columnPinning: columnPinning
    },
    manualPagination: manualPagination,
    pageCount: manualPagination ? Math.ceil(totalRows / pagination.pageSize) : undefined,
    onPaginationChange: setPagination,
    getCoreRowModel: (0, _reactTable.getCoreRowModel)(),
    onSortingChange: setSorting,
    onColumnOrderChange: setColumnOrder,
    onColumnVisibilityChange: setColumnVisibility,
    onExpandedChange: setExpanded,
    onGlobalFilterChange: setGlobalFilter,
    getSortedRowModel: (0, _reactTable.getSortedRowModel)(),
    getFilteredRowModel: (0, _reactTable.getFilteredRowModel)(),
    getPaginationRowModel: manualPagination ? undefined : (0, _reactTable.getPaginationRowModel)(),
    getExpandedRowModel: (0, _reactTable.getExpandedRowModel)(),
    enableRowSelection: true
  });

  /**
   * Reset column visibility and order to default
   */
  var resetColumnSettings = React.useCallback(function () {
    setColumnOrder(columnIds);
    setColumnVisibility({});
    localStorage.removeItem(getStorageKey(id, 'columnOrder'));
    localStorage.removeItem(getStorageKey(id, 'columnVisibility'));
    localStorage.removeItem(getStorageKey(id, 'sorting'));
    localStorage.removeItem(getStorageKey(id, 'pagination'));
    localStorage.removeItem(getStorageKey(id, 'columnPinning'));
  }, [columnIds, id]);
  return {
    table: table,
    columnOrder: columnOrder,
    setColumnOrder: setColumnOrder,
    columnVisibility: columnVisibility,
    setColumnVisibility: setColumnVisibility,
    pagination: pagination,
    setPagination: setPagination,
    sorting: sorting,
    setSorting: setSorting,
    expanded: expanded,
    setExpanded: setExpanded,
    globalFilter: globalFilter,
    setGlobalFilter: setGlobalFilter,
    columnPinning: columnPinning,
    setColumnPinning: setColumnPinning,
    resetColumnSettings: resetColumnSettings
  };
};
exports.useTableState = useTableState;